import { useIncident } from 'components/IAP/hooks/incidentHooks';
import { useOperationalPeriodWindow } from 'components/IAP/hooks/useOperationalPeriodWindow';

/**
 * Resolves ICS-204 Boxes 1-2 for the future planning period this widget
 * targets.
 *
 * The period is pinned rather than taken from the view, because a 204 is
 * authored for one specific period regardless of which package is being
 * browsed.
 */
export function useIcs204HeaderContext(periodNumber: number): {
  incidentName: string;
  opFrom: string;
  opTo: string;
} {
  const incident = useIncident();
  const { opFrom, opTo } = useOperationalPeriodWindow(periodNumber);

  return { incidentName: incident.data?.name?.trim() ?? '', opFrom, opTo };
}
